import classNames from 'classnames';
import { HTMLProps } from 'react';
import './Checkbox.scss';

export type CheckboxVariantType = 'square' | 'circle';

export type CheckboxProps = HTMLProps<HTMLInputElement> & {
  className?: string;
  variant?: CheckboxVariantType;
};
export const Checkbox = ({ className, variant = 'square', ...props }: CheckboxProps) => (
  <input
    {...props}
    type="checkbox"
    className={classNames('checkbox', className, {
      [`checkbox-variant-${variant}`]: variant,
    })}
  />
);
